import { useQuery as defaultUseQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { UseQuery, QueryResult } from '@zapier/checkout/src/types';

import { changePlan_currentAccountQuery as CurrentAccountQuery } from './types/changePlan_currentAccountQuery';

export const currentAccountQuery = gql`
  query changePlan_currentAccountQuery($accountId: Int!) {
    account(id: $accountId) {
      companyName
      id
      name
      owner {
        id
        email
      }
      featureEnrollmentList {
        id
        featureName
        isEnrolled
      }
      switches
    }
  }
`;

type Options = {
  skip?: boolean;
};

export const useCurrentAccount = (
  accountId: number,
  options: Options = {},
  useQuery: UseQuery = defaultUseQuery
) => {
  const { data, error, loading }: QueryResult<CurrentAccountQuery> = useQuery(
    currentAccountQuery,
    {
      fetchPolicy: 'network-only',
      skip: Boolean(options?.skip),
      variables: { accountId },
    }
  );

  return {
    currentAccount: data?.account,
    error: error
      ? 'There was an issue loading account data. Please try again.'
      : null,
    isLoading: loading,
  };
};
